// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5b957d3c","453":"78aa9b07","455":"6ef704b5"}[chunkId] + ".chunk.js";
};